var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-underlay-header"},[_c('div',{staticClass:"companylogo"},[_c('img',{attrs:{"alt":"","src":"https://cdn.jsdelivr.net/gh/affinityteam/www-assets/v1/images/logo/affinity1_300_90.png"}})]),_c('div',{staticClass:"heading"},[_vm._v("Affinity Self Service")]),_c('div',{staticClass:"heading mobile"},[_vm._v("Self Service")])])
}]

export { render, staticRenderFns }